export const visitorUniqueId = 'VISITOR-UNIQUE-ID' as const;
export const unknownAccountId = 'UNKNOWN-ACCOUNT-ID' as const;
